var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullInventory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1722 3.29972L9.12333 0.167501C8.62 -0.0569434 8.04333 -0.0547212 7.54333 0.167501L0.494445 3.29972C0.193333 3.43417 0 3.73195 0 4.06195V12.7842C0 13.5508 0.453333 14.2486 1.15444 14.5619L7.54333 17.4008C7.79444 17.5131 8.06444 17.5686 8.33333 17.5686C8.60222 17.5686 8.87222 17.5131 9.12333 17.4019L15.5122 14.5619C16.2133 14.2497 16.6667 13.5519 16.6667 12.7853V4.06195C16.6667 3.73306 16.4733 3.43417 16.1722 3.29972ZM8.22111 1.68972C8.29222 1.65861 8.37444 1.65861 8.44556 1.68972L9.61333 2.20861L4.16556 4.62972L2.88444 4.06083L8.22 1.68972H8.22111ZM8.44556 6.43306C8.37444 6.46417 8.29222 6.46528 8.22 6.43306L6.21889 5.54417L11.6667 3.12306L13.7811 4.06306L8.44556 6.43417V6.43306ZM15 12.7842C15 12.8942 14.9344 12.9931 14.8356 13.0386L9.16667 15.5575V7.9375L15 5.34528V12.7842Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullInventory);
export default __webpack_public_path__ + "static/media/full-inventory.f46bfc5f69f02c8e749ce9ce2b333a38.svg";
export { ForwardRef as ReactComponent };